<div *ngIf="!currentUser">
  <router-outlet></router-outlet>
</div>

<div *ngIf="currentUser" (click)="onValidateCookieUser()">
  <div id="content">
    <app-header-emi></app-header-emi>

    <div class="container-fluid pt-0 container__custom">
      <div class="navbar__lateral">
        <div class="navbar__lateral__main scroll-y-panel">

          <app-menu-item *ngFor="let item of navBar" [item]="item" (click)="onShowSecondaryNav(item)"></app-menu-item>


          <div id="languageMenu" class="justify-all-center mb-4">
            <div class="navbar-brand display-table-cell">

              <div class="row">
                <div class="col-12 mb-2 ml-1">
                  <button class="btn btn-none text-white" (click)="logout()">
                    <img alt="" src="assets/icons/ico_CerrarSesion.svg" class="logout-icon">
                  </button>
                </div>

                <div class="col-12 img-language d-none">
                  <img alt="" [src]="this.imgPath" class="flag mt-2" (click)="onChangeMenu('lg')">
                  <br>
                  <div *ngIf="language === 'es'">
                    <p class="fz-11-px mt-1">Español</p>
                  </div>
                  <div *ngIf="language === 'en'">
                    <p class="fz-11-px mt-1">English</p>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>

        <div class="navbar__lateral__secondary" [ngClass]="{
          'secondary__active': navBarSecondary.length > 0} ">
          <app-menu-item *ngFor="let item of navBarSecondary" [item]="item" [class.d-none]="!item.show"
            (click)="onShowSecondaryNav(item)"></app-menu-item>
        </div>


      </div>


      <div class="container__custom__pages">
        <div class="container__custom__pages__routes">
          <router-outlet></router-outlet>
        </div>
      </div>

    </div>
    <app-footer></app-footer>

  </div>
  <div class="overlay" [class.loading]="loading" (click)="dismissSideBar()"></div>
</div>

<!-- loading -->
<div class="overlay-loading" [class.d-block]="loading" [class.d-none]="!loading"></div>
<div class="row">
  <div *ngIf="loading" class="loadingGif">
    <div class="row">
      <div class="col-12 text-center ">
        <h1 style="font-size: 35px; color: white;">
          <i class="fa-solid fa-spinner fa-spin"></i>
        </h1>
      </div>
    </div>
  </div>
</div>